import { useTranslation } from "react-i18next";
import { useGHContext } from "./contexts/groupHierarchy.context";
import { FC } from "react";
import svgIcons from "../../../assets/svg/svgIcons";

type THierarchyBreadcrumbTagProps = {
  group_id: string;
  lastGroup?: boolean;
}

const HierachyBreadcrumbTag: FC<THierarchyBreadcrumbTagProps> = ({ group_id, lastGroup = false }) => {
  const { hierarchyOnDisplay } = useGHContext();

  const levelOfGroup =
    hierarchyOnDisplay
      .findIndex(
        (level) =>
          level?.groups?.find(
            (group) => group?.groupid === group_id
          )
      );
  const parentOfGroup = hierarchyOnDisplay[levelOfGroup - 1]?.selectedGroup;

  const truncateTag = !lastGroup && levelOfGroup > 0;

  return (
    <>
      {!!parentOfGroup && (
        <>
          {/* Generates breadcrumb tags for parent groups recursively */}
          <HierachyBreadcrumbTag group_id={parentOfGroup} />
          <span className="inline-flex h-8 items-center self-center">
            <img
              className="size-6"
              src={svgIcons.ChevronRight}
              alt="chevron right"
            />
          </span>
        </>
      )}
      <span
        className={
          `rounded-full inline-block leading-8 ${lastGroup === true
            ? ' text-heading-gray222'
            : ''
          }${truncateTag ? ' max-w-16 whitespace-nowrap overflow-hidden text-ellipsis' : ''}`
        }
        title={group_id}
      >
        {group_id}
      </span>
    </>
  )
}
export default HierachyBreadcrumbTag;
